(function () {
    "use strict";

    angular.module("app").component("habilAddress", {
        template: `
            {{ $ctrl.address.Street }}
            {{ $ctrl.address.Number }}
            {{ $ctrl.address.Postbox }}
            <br>
            {{ $ctrl.address.Postal }}
            {{ $ctrl.address.City }}
            <br>
            {{ $ctrl.address.CodeCountry | codeValue:$ctrl.Countries }}
        `,
        bindings: { address: "=" },
        controller: Controller
    });

    Controller.$inject = ["$rootScope"];
    function Controller($rootScope) {
        this.Countries = $rootScope.codeCountries;
    }
})();